import { DISPLAY_DATE_FORMAT, formatDisplayDate } from '@/helpers/date';
import { formatUserDisplayName } from '@/helpers/user';

export const formatApprovalFlowDate = (createdAt) => (
  formatDisplayDate(createdAt) === '—' ? '' : formatDisplayDate(createdAt)
);

export const getTemplateStageSlotCounts = (template) => {
  const stages = template?.stages ?? [];
  const stageCount = stages.length;
  const slotCount = stages.reduce(
    (total, stage) => total + (stage?.slots?.length ?? 0),
    0,
  );

  return { stageCount, slotCount };
};

export const formatTemplateStageSlotSummary = (template) => {
  const { stageCount, slotCount } = getTemplateStageSlotCounts(template);
  const stageLabel = stageCount === 1 ? 'stage' : 'stages';
  const slotLabel = slotCount === 1 ? 'slot' : 'slots';

  return `${stageCount} ${stageLabel}: ${slotCount} ${slotLabel}`;
};

export const flattenTemplateSlots = (template) => {
  const stages = template?.stages ?? [];

  return stages.flatMap((stage) => (
    (stage?.slots ?? []).map((approvalSlot) => ({
      stageNumber: stage.stage_number,
      stageName: stage.name,
      name: approvalSlot.name,
      description: approvalSlot.description,
      approvers: (approvalSlot.approvers ?? []).map((u) => ({
        id: u.ulid,
        label: formatUserDisplayName(u),
      })),
    }))
  ));
};

export const buildSlotAssignmentsFromTemplate = (template) => (
  flattenTemplateSlots(template).map((approvalSlot) => ({
    ...approvalSlot,
    selectedUsers: approvalSlot.approvers,
  }))
);

export const buildSlotsFromTemplate = (assignments) => (
  (assignments ?? []).map((assignment) => ({
    userUlids: (assignment.selectedUsers ?? []).map((user) => user.id),
  }))
);

export const getTemplateNameByUlid = (templates, templateUlid) => {
  if (!templateUlid) return '';

  const match = (templates ?? []).find((template) => template.ulid === templateUlid);

  return match?.name ?? '';
};

export const sortApprovalFlowsByDateDesc = (flows = []) => (
  [...flows].sort((a, b) => {
    const aTime = new Date(a?.created_at ?? 0).getTime();
    const bTime = new Date(b?.created_at ?? 0).getTime();

    return bTime - aTime;
  })
);

export const getActiveFlow = (flows, ulid) => (
  (flows ?? []).find((flow) => flow.ulid === ulid)
);

export const getNewApproverIds = (approvalSlot, selectedUsers) => {
  const originalIds = new Set(approvalSlot.approvers.map((approver) => approver.ulid));

  return selectedUsers
    .map((selectedUser) => selectedUser.id)
    .filter((userId) => !originalIds.has(userId));
};

export { DISPLAY_DATE_FORMAT };
